/* eslint-disable react/no-unknown-property */
import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';
import { AssetIcon } from 'src/v2/components/ui/icons/assets';

import { primaryColors } from '~components/theme/styles/colors';
import { secondaryBox } from '~components/theme/styles/mixins';
import { ENativeAsset } from '~config/types';

import { TvlAreaGraph } from '../../statistics/graphs/tvlAreaGraph';
import SlideWrapper from '../SlideWrapper';

function FeesGeneratedSlide() {
  //need to get fees
  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Stack spacing={4}>
        <Stack spacing={2}>
          <Typography variant={'h4'}>How much fee has Vesta generated so far?</Typography>
          <Typography variant={'h6'} color={primaryColors[100]}>
            Fees from the Vesta Reference Rate
          </Typography>
        </Stack>
        <TvlAreaGraph />
        <Typography variant={'body1'} color={primaryColors[400]}>
          Vesta also has other fees such as mint fee (deprecated) and redemption fee (deprecated), ETH fee
          from GLP, esGMX from GMX and GLP)
        </Typography>
        <Box sx={secondaryBox}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Stack
              spacing={4}
              direction={{ xs: 'column', sm: 'row' }}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <AssetIcon size={42} noBg noBorder asset={ENativeAsset.VSTA} />
              <Stack textAlign={'left'}>
                <Typography variant={'h6'} color={primaryColors[100]}>
                  Learn more about the Saving Module
                </Typography>
                <Typography variant={'body2'} color={primaryColors[400]}>
                  and our Fee Schedule
                </Typography>
              </Stack>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} mt={{ xs: 4, sm: 0 }}>
              <ButtonWithIcon variant="secondary" sx={{ width: { xs: '100%', sm: 170 } }} iconType="asterisk">
                SAVING MODULE
              </ButtonWithIcon>
              <ButtonWithIcon variant="secondary" sx={{ width: { xs: '100%', sm: 240 } }} iconType="asterisk">
                CURRENT FEE SCHEDULE
              </ButtonWithIcon>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </SlideWrapper>
  );
}

export default FeesGeneratedSlide;
